// TODO: remover esse service
export interface ResponseModel<T> {
    httpCode: number;
    message: string;
    response: T;
}
